// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.export-submissions-to-pdf-modal {
  width: 100%;
  max-height: 450px;
  padding: 32px 32px 130px !important;
}
.export-submissions-to-pdf-modal.pdf-generation {
  max-width: 490px;
  max-height: 200px;
  background-color: #fff;
}
.export-submissions-to-pdf-modal-overlay {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: fixed;
  display: flex;
  padding-top: 24px;
  padding-bottom: 24px;
  align-items: center;
  justify-content: center;
}
.export-submissions-to-pdf-modal .modal-body.settings {
  padding: 26px 18px;
  border-radius: 8px;
  background-color: #fff;
  border-left: 4px solid var(--Primary-100, #f4ebff);
  box-shadow: 0px 1px 3px 0px rgba(16, 24, 40, 0.1019607843);
}
.export-submissions-to-pdf-modal .modal-body__header {
  display: flex;
  gap: 8px;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: var(--Secondary-Text, #667085);
}
.export-submissions-to-pdf-modal .modal-body__main {
  margin-top: 16px;
}
.export-submissions-to-pdf-modal .modal-body__main .name_field__label {
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  color: var(--Secondary-eading, #101828);
}
.export-submissions-to-pdf-modal .modal-body__main .name_field__input {
  margin-top: 8px;
}
.export-submissions-to-pdf-modal .modal-body__main .form-control-radio {
  margin-bottom: 0;
}
.export-submissions-to-pdf-modal .modal-body__main .radiobutton-row {
  display: flex;
  gap: 34px;
  margin-top: 44px;
  align-items: center;
}
.export-submissions-to-pdf-modal .modal-body__main .radiobutton-row__label {
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  color: var(--Secondary-eading, #101828);
}
.export-submissions-to-pdf-modal .modal-body__main .pdf-generation-title {
  font-size: 18px;
  font-weight: 600;
  line-height: 20px;
  color: var(--Secondary-eading, #101828);
}
.export-submissions-to-pdf-modal .modal-body__main .pdf-generation-description {
  margin-top: 8px;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: var(--Secondary-Text, #667085);
}`, "",{"version":3,"sources":["webpack://./src/pages/corporate-library/submission/components/ExportToPDFModal/styles.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,iBAAA;EACA,mCAAA;AACF;AACE;EACE,gBAAA;EACA,iBAAA;EACA,sBAAA;AACJ;AAEE;EACE,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAAJ;AAII;EACE,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kDAAA;EACA,0DAAA;AAFN;AAKI;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qCAAA;AAHN;AAMI;EACE,gBAAA;AAJN;AAOQ;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uCAAA;AALV;AAQQ;EACE,eAAA;AANV;AAUM;EACE,gBAAA;AARR;AAWM;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;AATR;AAWQ;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uCAAA;AATV;AAaM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uCAAA;AAXR;AAaM;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qCAAA;AAXR","sourcesContent":[".export-submissions-to-pdf-modal {\n  width: 100%;\n  max-height: 450px;\n  padding: 32px 32px 130px !important;\n\n  &.pdf-generation {\n    max-width: 490px;\n    max-height: 200px;\n    background-color: #fff;\n  }\n\n  &-overlay {\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    position: fixed;\n    display: flex;\n    padding-top: 24px;\n    padding-bottom: 24px;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .modal-body {\n    &.settings {\n      padding: 26px 18px;\n      border-radius: 8px;\n      background-color: #fff;\n      border-left: 4px solid var(--Primary-100, #f4ebff);\n      box-shadow: 0px 1px 3px 0px #1018281a;\n    }\n\n    &__header {\n      display: flex;\n      gap: 8px;\n      align-items: center;\n      font-size: 16px;\n      font-weight: 400;\n      line-height: 24px;\n      color: var(--Secondary-Text, #667085);\n    }\n\n    &__main {\n      margin-top: 16px;\n\n      .name_field {\n        &__label {\n          font-size: 14px;\n          font-weight: 500;\n          line-height: 16px;\n          color: var(--Secondary-eading, #101828);\n        }\n\n        &__input {\n          margin-top: 8px;\n        }\n      }\n\n      .form-control-radio {\n        margin-bottom: 0;\n      }\n\n      .radiobutton-row {\n        display: flex;\n        gap: 34px;\n        margin-top: 44px;\n        align-items: center;\n\n        &__label {\n          font-size: 14px;\n          font-weight: 500;\n          line-height: 16px;\n          color: var(--Secondary-eading, #101828);\n        }\n      }\n\n      .pdf-generation-title {\n        font-size: 18px;\n        font-weight: 600;\n        line-height: 20px;\n        color: var(--Secondary-eading, #101828);\n      }\n      .pdf-generation-description {\n        margin-top: 8px;\n        font-size: 16px;\n        font-weight: 400;\n        line-height: 24px;\n        color: var(--Secondary-Text, #667085);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
